
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.79 30.641c-.8-2.5-2.1-4.8-4.2-6.6-1.4-1.2-3-1.7-4.5-2.3.7-4.3 1.3-8.6 2-12.9.2-1.4-1-2.9-1.3-.8-.7 4.3-1.3 8.7-2 13-.2-.1-.4-.2-.5-.4-.9-.7-1.8-1.1-2.6-1.3.2-2.9.3-5.8.5-8.6.1-1.9-1.3-1.9-1.4 0-.2 2.9-.3 5.7-.5 8.6-1.8.3-3.2 1.9-3.5 4.2-.9.3-2.1.8-2.8.6-.4-.1-1.7-1.9-2.3-2.2-3-1.7-5.7-.1-8.1 1.8-.9.7-1.7 1.8-2.5 2.4-.8.6-2 .6-2.9 1.3-1.1.8-1.8 2.3-2 3.7-.9.6-1.6 1.4-2 2.8-1.1 4.4 2.8 9.3 5.6 12.2 4.4 4.5 10 7.2 16.3 7.4 8.9-.5 20.6-7.5 21.9-17.3.4-3.4-1-4.9-3.2-5.6zm-.2 9h-37v-.1c-.3-.2-.4-.4-.6-.6h37.9c0 .2-.2.4-.3.7zm1.3-3.9h-39.4c.2-.3.3-.6.6-.9.7-.8 1-1.3 1.2-1.5.1 0 .2 0 .3-.1.1 0 .3.1.7 0 .2 0 .4-.1.5-.1.4 0 .8-.1 1.2-.1 1.6 0 3.5.2 4.9.2h27c2.1.4 2.9 1.4 3 2.5zm-11.3-5.6c1-.8 2.6-1 3.4 0h-3.4zm-.4 0h-2.2c.6-.5 1.4-.5 2.2 0zm-4.1 0h-3.4c.4-.1 2.4-.3 2.6-.2.4 0 .6.1.8.2zm12.6 0h-3-.1c-.2-1.6-.9-3.3-2.6-3.8-.7-.2-1.2 0-1.7.2.1-.4.1-.9.2-1.3 3.2.1 5.7 2.2 7.2 4.9zm-8.4-5.7c-.1.8-.2 1.6-.4 2.3-.7.1-1.4.1-2.2.2-.5.1-.3.2-.6.3l.3-4.8c1.2.4 2.3 1.2 2.9 2zm-23.1 5.1c.2 0 .4-.3.5-.5.5-1.2 2.3-2.6 3.5-3.2 3.1-1.7 6.2-2.6 8.3 1.7.1.2.4.7.7.4.8-.9 1.9-1.4 3.2-1.4.6-.1.7-1.1.7-1.6-.1-1.9.8-2.7 2-2.7l-.3 4.5c-.1 0-.2-.1-.2-.1-.9-.2-1.9 0-2.7.4-1.1.7-1.5 1.8-1.6 3-4.8 0-10.1-.6-15-.1-.4 0-.8 0-1.2.1.6-.4 1.3-.6 2.1-.5zm14.8 20.7c-6.2-.2-11.8-2.9-16-7.5h32.1c-4.2 4.6-9.8 7.2-16.1 7.5z"}})])
          )
        }
      }
    